<app-common-table
  #cnTable
  [title]="'Completed Forms & Documents'"
  [actions]="actions"
  [burgerActions]="burgerActions"
  [columns]="columns"
  (onLoadItemsEvent)="onLoadItemsEvent($event)"
  (onActionClickEmit)="onActionClickEmit($event)">
</app-common-table>
